/*
 * @Description: 
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2022-07-14 09:50:19
 * @LastEditTime: 2023-09-15 11:13:46
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */
import {
  get,
  post
} from '../index'
export default {
  // 代理商申请数据
  agentApplyList (querys) {
    return get('massage/admin/AdminSetting/agentApplyList', querys)
  },
  // 代理商阅读信息
  agentApplyCheck (querys) {
    return post('massage/admin/AdminSetting/agentApplyCheck', querys)
  },
  // 代理商下拉
  adminSelect (querys) {
    return get('massage/admin/AdminSetting/adminSelect', querys)
  },
  // 代理商列表
  franchiseeList (querys) {
    return get('massage/admin/AdminSetting/adminList', querys)
  },
  // 代理商用户列表
  userList (querys) {
    return get('massage/admin/AdminSetting/userSelect', querys)
  },
  // 添加代理商
  adminAdd (querys) {
    return post('massage/admin/AdminSetting/adminAdd', querys)
  },
  // 删除代理商
  adminStatusUpdate (querys) {
    return post('massage/admin/AdminSetting/adminStatusUpdate', querys)
  },
  // 编辑代理商
  adminUpdate (querys) {
    return post('massage/admin/AdminSetting/adminUpdate', querys)
  },
  // 代理商详情
  adminInfo (querys) {
    return get('massage/admin/AdminSetting/adminInfo', querys)
  },
  // 获取支付宝账号信息
  getAdminAliAccount (querys) {
    return get('massage/admin/AdminUser/getAdminAliAccount', querys)
  },
  // 佣金列表
  cashList (querys) {
    return get('massage/admin/AdminUser/cashList', querys)
  },
  // 佣金提现
  applyWallet (querys) {
    return post('massage/admin/AdminUser/applyWallet', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/agent.js